import axios from 'axios'
import { ErrorMessage, Form, Formik } from 'formik'
import { Button, Form as frm } from 'react-bootstrap'
import InputGroup from 'react-bootstrap/InputGroup'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import Select from 'react-select'
import * as Yup from 'yup'
import FormikControl from '../../../components/FormikControl'
import SellerModal from '../../../components/SellerModal'
import TextError from '../../../components/TextError'
import { customStyles } from '../../../components/customStyles'
import {
  encodeId,
  focusInput,
  prepareNotificationData,
  showToast
} from '../../../lib/AllGlobalFunction'
import axiosProvider from '../../../lib/AxiosProvider'
import { getBaseUrl } from '../../../lib/GetBaseUrl'

import {
  _alphabetRegex_,
  _emailRegex_,
  _passwordRegex_,
  _phoneNumberRegex_
} from '../../../lib/Regex'
import { _exception } from '../../../lib/exceptionMessage'

const CreateSellerModal = ({
  setLoading,
  initialValues,
  setInitialValues,
  modalShow,
  setModalShow,
  isModalRequired,
  fetchData,
  toast,
  setToast
}) => {
  const { userInfo } = useSelector((state) => state?.user)
  const location = useLocation()
  const validationSchema = Yup.object().shape({
    firstName: Yup.string().required('First name is required'),
    lastName: Yup.string().required('Last name is required'),
    emailID:
      !initialValues?.createSeller?.id &&
      Yup.string()
        .matches(_emailRegex_, 'Please enter a valid email id')
        .required('Email id is required'),

    mobileNo: Yup.string()
      .required('Mobile number is required')
      .matches(
        /^[6-9]{1}[0-9]{9}$/,
        'Mobile number starting ranges between 6 - 9'
      ),
    password:
      !initialValues?.createSeller?.id &&
      Yup.string()
        .matches(
          _passwordRegex_,
          'Password must be at least 6 characters with a mix of lowercase, uppercase, digit, and special characters.'
        )
        .required('Password is required'),

    cpass:
      !initialValues?.createSeller?.id &&
      Yup.string()
        .oneOf([Yup.ref('password'), null], 'Passwords must match')
        .required('Confirm password required')
  })

  const renderComponent = () => {
    return (
      <Formik
        enableReinitialize
        initialValues={initialValues?.createSeller}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {({ values, setFieldValue, errors, validateForm }) => (
          <Form id='createSeller' className='add_seller_form'>
            <h3 className='text-center my-3 head_h3'>
              {values?.id ? 'Update' : 'Create'} Seller Account
            </h3>
            {isModalRequired ? (
              <></>
            ) : (
              <div
                className='modal-header m-auto my-4'
                style={{ width: 'fit-content' }}
              >
                {!values?.id ? (
                  <div className='ml-auto position-relative'>
                    <ul id='progressbar'>
                      <li className='active' id='account'>
                        <i className='m-icon m-icon--create_account active'></i>
                        <strong>Create Account</strong>
                      </li>
                      <li className='' id='personal'>
                        <i className='m-icon m-icon--kyc_info'></i>
                        <strong>KYC Info</strong>
                      </li>
                      <li className='' id='payment'>
                        <i className='m-icon m-icon--gst_info'></i>
                        <strong>Tax Info</strong>
                      </li>
                      <li className='' id='confirm'>
                        <i className='m-icon m-icon--warehouse'></i>
                        <strong>Warehouse</strong>
                      </li>
                    </ul>
                  </div>
                ) : (
                  <></>
                )}
              </div>
            )}

            <div className='row'>
              <div className='col-md-6'>
                <div className='input-file-wrapper mb-3'>
                  <FormikControl
                    isRequired
                    control='input'
                    label='First Name'
                    id='firstName'
                    type='text'
                    name='firstName'
                    value={values?.firstName}
                    placeholder='First Name'
                    onChange={(e) => {
                      let inputValue = e?.target?.value
                      let isValid = _alphabetRegex_.test(inputValue)
                      let fieldName = e?.target?.name
                      if (!inputValue || isValid) {
                        setFieldValue(fieldName, inputValue)
                      }
                    }}
                    onBlur={(e) => {
                      let fieldName = e?.target?.name
                      setFieldValue(fieldName, values[fieldName]?.trim())
                    }}
                  />
                </div>
              </div>
              <div className='col-md-6'>
                <div className='input-file-wrapper mb-3'>
                  <FormikControl
                    isRequired
                    control='input'
                    label='Last Name'
                    id='lastName'
                    type='text'
                    name='lastName'
                    value={values?.lastName}
                    placeholder='Last Name'
                    onChange={(e) => {
                      let inputValue = e?.target?.value
                      let isValid = _alphabetRegex_.test(inputValue)
                      let fieldName = e?.target?.name
                      if (!inputValue || isValid) {
                        setFieldValue(fieldName, inputValue)
                      }
                    }}
                    onBlur={(e) => {
                      let fieldName = e?.target?.name
                      setFieldValue(fieldName, values[fieldName]?.trim())
                    }}
                  />
                </div>
              </div>
            </div>

            {/* {!values?.id && (
              <div className='row'>
                <div className='col-md-6 m-auto'>
                  <div className='input-file-wrapper mb-3'>
                    <FormikControl
                      isRequired
                      control='input'
                      label='GST Number'
                      id='gstNo'
                      type='text'
                      name='gstNo'
                      placeholder='Tax Number'
                      // onChange={(e) => {
                      //   let regx = new RegExp(
                      //     /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/
                      //   )
                      //   if (regx.test(e?.target?.value)) {
                      //     const resp = axios
                      //       .get(
                      //         `https://gst-return-status.p.rapidapi.com/free/gstin/${e?.target?.value}`,
                      //         {
                      //           headers: {
                      //             'Content-Type': 'application/json',
                      //             'X-RapidAPI-Key':
                      //               '79dc2f4875msh7a098852c46042bp182f46jsna2abc4d2ddcb',
                      //             'X-RapidAPI-Host':
                      //               'gst-return-status.p.rapidapi.com'
                      //           }
                      //         }
                      //       )
                      //       .then((res) => {
                      //         if (res?.status === 200) {
                      //           // setFieldValue('bankName', res?.data?.BANK)
                      //         }
                      //       })
                      //     // fetchDetails(e?.target?.value)
                      //   }
                      // }}
                    />
                  </div>
                </div>
                <div className='col-md-6'>
                  <div className='input-file-wrapper mb-3'>
                    <label className='form-label required'>KYC For</label>
                    <ReactSelect
                      id='kycFor'
                      name='kycFor'
                      value={
                        values?.kycFor && {
                          value: values?.kycFor,
                          label: values?.kycFor
                        }
                      }
                      options={[
                        {
                          label: 'Supplier',
                          value: 'Supplier'
                        },
                        {
                          label: 'Hubspot',
                          value: 'Hubspot'
                        },
                        {
                          label: 'Brand',
                          value: 'Brand'
                        }
                      ]}
                      onChange={(e) => {
                        if (e) {
                          setFieldValue('kycFor', e?.value)
                        }
                      }}
                    />
                  </div>
                </div>
              </div>
            )} */}

            <div className='row'>
              <div className='col-md-6'>
                <div className='input-file-wrapper mb-3'>
                  <FormikControl
                    isRequired
                    disabled={values?.id ? true : false}
                    control='input'
                    label='Email Id'
                    id='emailID'
                    type='email'
                    name='emailID'
                    value={
                      values?.userName ? values?.userName : values?.emailID
                    }
                    placeholder='Email Id'
                    onBlur={(e) => {
                      let fieldName = e?.target?.name
                      setFieldValue(fieldName, values[fieldName]?.trim())
                    }}
                  />
                </div>
              </div>
              <div className='col-md-6'>
                <label class='required form-label' for='mobileNo'>
                  Mobile Number
                </label>
                <InputGroup className='mb-3'>
                  <InputGroup.Text id='inputGroup-sizing-default'>
                    +245
                  </InputGroup.Text>
                  <frm.Control
                    isRequired
                    control='input'
                    label='Mobile Number'
                    id='mobileNo'
                    type='text'
                    name='mobileNo'
                    maxLength='15'
                    placeholder='Mobile Number'
                    value={values?.mobileNo}
                    onChange={(e) => {
                      let inputValue = e?.target?.value
                      let isValid = _phoneNumberRegex_.test(inputValue)
                      let fieldName = e?.target?.name
                      if (!inputValue || isValid) {
                        setFieldValue(fieldName, inputValue)
                      }
                    }}
                    onBlur={(e) => {
                      let fieldName = e?.target?.name
                      setFieldValue(fieldName, values[fieldName]?.trim())
                    }}
                  />
                </InputGroup>
              </div>
            </div>

            {!values?.id && (
              <div className='row'>
                <div className='col-md-6'>
                  <div className='input-wrapper pv-login-password mb-4 pos-relative'>
                    <FormikControl
                      isRequired
                      control='input'
                      label='Password'
                      id='password'
                      type={values?.newPasswordVisible ? 'text' : 'password'}
                      name='password'
                      className='he-10'
                      placeholder='Password'
                      onBlur={(e) => {
                        let fieldName = e?.target?.name
                        setFieldValue(fieldName, values[fieldName]?.trim())
                      }}
                      maxLength={50}
                    />
                    <div
                      className='eye-absolute'
                      style={{
                        position: 'absolute',
                        top: '1.8rem',
                        right: '10px'
                      }}
                    >
                      {!values?.newPasswordVisible ? (
                        <svg
                          xmlns='http://www.w3.org/2000/svg'
                          width='18'
                          height='18'
                          onClick={() => {
                            setFieldValue(
                              'newPasswordVisible',
                              !values?.newPasswordVisible
                            )
                          }}
                          viewBox='0 0 24 24'
                          fill='none'
                          stroke='currentColor'
                          strokeWidth='2'
                          strokeLinecap='round'
                          strokeLinejoin='round'
                          className={`feather feather-eye link-icon toggle-password eye-icon w-75`}
                          data-password=''
                        >
                          <path d='M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z'></path>
                          <circle cx='12' cy='12' r='3'></circle>
                        </svg>
                      ) : (
                        <svg
                          xmlns='http://www.w3.org/2000/svg'
                          width='18'
                          height='18'
                          viewBox='0 0 24 24'
                          fill='none'
                          stroke='currentColor'
                          onClick={() => {
                            setFieldValue(
                              'newPasswordVisible',
                              !values?.newPasswordVisible
                            )
                          }}
                          strokeWidth='2'
                          strokeLinecap='round'
                          strokeLinejoin='round'
                          className='feather feather-eye-off link-icon toggle-password eye-off-icon w-75'
                          data-password=''
                        >
                          <path d='M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24'></path>
                          <line x1='1' y1='1' x2='23' y2='23'></line>
                        </svg>
                      )}
                    </div>
                  </div>
                </div>
                <div className='col-md-6'>
                  <div className='input-wrapper pv-login-password mb-4 pos-relative'>
                    <FormikControl
                      isRequired
                      control='input'
                      label='Confirm Password'
                      id='cpass'
                      type={
                        values?.confirmPasswordVisible ? 'text' : 'password'
                      }
                      name='cpass'
                      placeholder='Confirm Password'
                      onBlur={(e) => {
                        let fieldName = e?.target?.name
                        setFieldValue(fieldName, values[fieldName]?.trim())
                      }}
                      maxLength={50}
                    />
                    <div
                      className='eye-absolute'
                      style={{
                        position: 'absolute',
                        top: '1.8rem',
                        right: '10px'
                      }}
                    >
                      {!values?.confirmPasswordVisible ? (
                        <svg
                          xmlns='http://www.w3.org/2000/svg'
                          width='18'
                          height='18'
                          onClick={() => {
                            setFieldValue(
                              'confirmPasswordVisible',
                              !values?.confirmPasswordVisible
                            )
                          }}
                          viewBox='0 0 24 24'
                          fill='none'
                          stroke='currentColor'
                          strokeWidth='2'
                          strokeLinecap='round'
                          strokeLinejoin='round'
                          className={`feather feather-eye link-icon toggle-password eye-icon w-75`}
                          data-password=''
                        >
                          <path d='M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z'></path>
                          <circle cx='12' cy='12' r='3'></circle>
                        </svg>
                      ) : (
                        <svg
                          xmlns='http://www.w3.org/2000/svg'
                          width='18'
                          height='18'
                          viewBox='0 0 24 24'
                          fill='none'
                          stroke='currentColor'
                          onClick={() => {
                            setFieldValue(
                              'confirmPasswordVisible',
                              !values?.confirmPasswordVisible
                            )
                          }}
                          strokeWidth='2'
                          strokeLinecap='round'
                          strokeLinejoin='round'
                          className='feather feather-eye-off link-icon toggle-password eye-off-icon w-75'
                          data-password=''
                        >
                          <path d='M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24'></path>
                          <line x1='1' y1='1' x2='23' y2='23'></line>
                        </svg>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}
            {values?.id && (
              <div className='row'>
                <div className='col-md-6'>
                  <div className='input-file-wrapper mb-3'>
                    <label className='form-label required'>Status</label>
                    <Select
                      id='status'
                      menuPortalTarget={document.body}
                      placeholder='Select status'
                      value={
                        values?.status && {
                          value: values?.status,
                          label: values?.status
                        }
                      }
                      styles={customStyles}
                      // isDisabled={!initialdata ? true : false}
                      options={[
                        {
                          label: 'Active',
                          value: 'Active'
                        },
                        {
                          label: 'Inactive',
                          value: 'Inactive'
                        },
                        {
                          label: 'Pending',
                          value: 'Pending'
                        }
                      ]}
                      onChange={(e) => {
                        if (e) {
                          setFieldValue('status', e?.value)
                        }
                      }}
                    />
                    <ErrorMessage name='status' component={TextError} />
                  </div>
                </div>
              </div>
            )}

            {!isModalRequired && (
              <Button
                type='submit'
                id='createSeller'
                onClick={() => {
                  validateForm()?.then((focusError) =>
                    focusInput(Object?.keys(focusError)?.[0])
                  )
                }}
              >
                Submit details
              </Button>
            )}
          </Form>
        )}
      </Formik>
    )
  }

  const onSubmit = async (values) => {
    values = { ...values, email: values?.email ?? values?.userName }
    if (!values?.id) {
      let deviceId = `Hashkart${Math.floor(Math.random() * 1000000000)}`
      setLoading(true)
      const config = {
        headers: {
          'Content-Type': 'application/json'
        }
      }
      try {
        setLoading(true)
        const response = await axios.post(
          `${getBaseUrl()}/Account/Seller/SignUp`,
          {
            ...values,
            deviceId
          },
          config
        )

        setLoading(false)

        if (response?.data?.code === 200) {
          if (!values?.id) {
            setModalShow((draft) => {
              draft.createSeller = false
              draft.basicInfo = true
              draft.gstInfo = false
              draft.warehouse = false
            })
            let userID = response?.data?.currentUser?.userId
            setInitialValues({
              ...initialValues,
              createSeller: {
                ...values,
                userID
              },
              basicInfo: {
                ...initialValues?.basicInfo,
                userID,
                kycFor: values?.kycFor
              },
              gstInfo: {
                ...initialValues?.gstInfo,
                userID,
                gstNo: values?.gstNo
              },
              warehouse: {
                ...initialValues?.warehouse,
                userID,
                gstNo: values?.gstNo
              }
            })
          } else {
            setModalShow((draft) => {
              draft.createSeller = false
            })
          }
          axiosProvider({
            endpoint: 'Notification',
            method: 'POST',
            data: prepareNotificationData({
              reciverId: values?.id
                ? values?.id
                : response?.data?.data?.currentUser?.userID,
              userId: userInfo?.userId,
              userType: userInfo?.userType,
              notificationTitle: `Seller: ${values?.firstName} ${
                values?.lastName
              } ${
                values?.id
                  ? 'updated details successfully'
                  : 'registered successfully'
              }`,
              notificationDescription: `${
                values?.id ? 'Update' : 'Created'
              } by ${userInfo?.fullName}`,
              url: `/manage-seller/seller-details/${
                values?.id
                  ? encodeId(values?.id)
                  : encodeId(response?.data?.currentUser?.userId)
              }`,
              notifcationsof: 'Seller'
            })
          })
          fetchData()
        }
        showToast(toast, setToast, response)
      } catch {
        setLoading(false)

        showToast(toast, setToast, {
          data: {
            message: _exception?.message,
            code: 204
          }
        })
      }
    } else {
      try {
        setLoading(true)
        const response = await axiosProvider({
          method: 'PUT',
          endpoint: 'SellerData/Update',
          data: values,
          oldData: initialValues?.createSeller,
          userId: userInfo?.userId,
          location: location.pathname
        })
        setLoading(false)
        if (response?.data?.code === 200) {
          setModalShow((draft) => {
            draft.createSeller = false
          })
          axiosProvider({
            endpoint: 'Notification',
            method: 'POST',
            data: prepareNotificationData({
              reciverId: values?.id
                ? values?.id
                : response?.data?.data?.currentUser?.userID,
              userId: userInfo?.userId,
              userType: userInfo?.userType,
              notificationTitle: `Seller: ${values?.firstName} ${
                values?.lastName
              } ${
                values?.id
                  ? 'updated details successfully'
                  : 'registered successfully'
              }`,
              notificationDescription: `${
                values?.id ? 'Update' : 'Created'
              } by ${userInfo?.fullName}`,
              url: `/manage-seller/seller-details/${
                values?.id
                  ? encodeId(values?.id)
                  : encodeId(response?.data?.currentUser?.userId)
              }`,
              notifcationsof: 'Seller'
            })
          })
          fetchData()
        }
        showToast(toast, setToast, response)
      } catch (error) {
        setLoading(false)

        showToast(toast, setToast, {
          data: {
            message: _exception?.message,
            code: 204
          }
        })
      }
    }
  }

  return isModalRequired ? (
    <SellerModal
      show={modalShow.createSeller}
      modalsize={'lg'}
      modalheaderclass={''}
      onHide={() => setModalShow((draft) => (draft.createSeller = false))}
      btnclosetext={''}
      closebtnvariant={''}
      backdrop={'static'}
      buttonclass={'justify-content-center'}
      formbuttonid={'createSeller'}
      submitname={'Submit Details'}
      modalclass={'create_seller'}
      modalheader={
        !initialValues?.createSeller?.id ? (
          <div className='ml-auto position-relative'>
            <ul id='progressbar'>
              <li className='active' id='account'>
                <i className='m-icon m-icon--create_account active'></i>
                <strong>Create Account</strong>
              </li>
              <li className='' id='personal'>
                <i className='m-icon m-icon--kyc_info'></i>
                <strong>KYC Info</strong>
              </li>
              <li className='' id='payment'>
                <i className='m-icon m-icon--gst_info'></i>
                <strong>Tax Info</strong>
              </li>
              <li className='' id='confirm'>
                <i className='m-icon m-icon--warehouse'></i>
                <strong>Pickup Address</strong>
              </li>
            </ul>
          </div>
        ) : (
          <></>
        )
      }
    >
      {renderComponent()}
    </SellerModal>
  ) : (
    renderComponent()
  )
}

export default CreateSellerModal
